"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "35",
    height: "35",
    viewBox: "0 0 35 35"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M17.5,0A17.5,17.5,0,1,0,35,17.5,17.51,17.51,0,0,0,17.5,0ZM15.75,9.64A1.66,1.66,0,0,1,17.5,8.08a1.66,1.66,0,0,1,1.75,1.56v8.7A1.66,1.66,0,0,1,17.5,19.9a1.66,1.66,0,0,1-1.75-1.56ZM17.5,26.92a2.07,2.07,0,1,1,2.07-2.07A2.07,2.07,0,0,1,17.5,26.92Z"
  }));
};

exports["default"] = _default;